import { lazy } from 'react';

import { AUT_EMIT, ADMIN, CONDICAO, DEM_JUD, FINALIDADE, LIMITE, MODELO_QUADRO, ITEM_VERIFICACAO, LISTA_VERIFICACAO, NORMATIVO, PARAM_CALCULO, PREFERENCIAS, PERFIL, PROGRAMA, SIM_LIMITE, TP_ANALISE, COC, LISTAS, CONSULTA_DOCUMENTO, PVL, GARANTIA, PANORAMA, CALCULOS, PAN_DOC_ENTE, PAN_ENDIVIDAMENTO, USUARIO, ENTIDADE } from './backend-features.config';
import { CON_AUT_EMIT, CON_CONDICAO, CON_DEM_JUD, CON_FINALIDADE, CON_LIMITE, CON_MODELO_QUADRO, CON_ITEM_VERIFICACAO, CON_LISTA_VERIFICACAO, CON_NORMATIVO, CON_PARAM_CALCULO, CON_PREFERENCIAS, CON_PERFIL, CON_PROGRAMA, CON_SIM_LIMITE, CON_TP_ANALISE, CON_COC, CON_LISTAS, ALT_PERFIL, CON_CONSULTA_DOCUMENTO, CON_PUBLICO_NORMATIVO, CON_PUBLICO_DEM_JUD, CON_PUBLICO_PVL, CON_PUBLICO_ELEMENTO, CON_PVL, CON_GARANTIA, CON_CALCULOS, CON_PANORAMA, CON_PAN_DOC_ENTE, CON_PAN_ENDIVIDAMENTO, CON_USUARIO, CON_ENTIDADE } from './backend-siglas.config';

const lazyLoader = {
  Home: lazy(() => import('pages/home/Home')),
  Login: lazy(() => import('pages/login/Login')),
  Logout: lazy(() => import('pages/logout/Logout')),
  LoginErro: lazy(() => import('pages/login_erro/LoginErro')),
  PageNotFound: lazy(() => import('pages/page_notfound/PageNotFound')),
  PageAccessDenied: lazy(() => import('pages/page_accessdenied/PageAccessDenied')),
  Finalidade: lazy(() => import('pages/finalidade/Finalidade')),
  AutoridadeEmitente: lazy(() => import('pages/autoridade_emitente/AutoridadeEmitente')),
  Normativo: lazy(() => import('pages/normativo/Normativo')),
  Admin: lazy(() => import('pages/admin/Admin')),
  Condicao: lazy(() => import('pages/condicao/Condicao')),
  Limite: lazy(() => import('pages/limite/Limite')),
  Programa: lazy(() => import('pages/programa/Programa')),
  TipoAnalise: lazy(() => import('pages/tipo_analise/TipoAnalise')),
  DemandaJudicial: lazy(() => import('pages/demanda_judicial/DemandaJudicial')),
  ParametroCalculo: lazy(()=> import('pages/parametro_calculo/ParametroCalculo')),
  ModeloQuadroAnalise: lazy(()=> import('pages/modeloquadroanalise/ModeloQuadroAnalise')),
  ItemVerificacao: lazy(()=> import('pages/item_verificacao/ItemVerificacao')),
  ListaVerificacao: lazy(()=> import('pages/lista_verificacao/ListaVerificacao')),
  Entidade: lazy(() => import('pages/entidade/Entidade')),
  LimiteSimulacao: lazy(()=> import('pages/limite_simulacao/LimiteSimulacao')),
  Preferencias: lazy(()=> import('pages/preferencias/Preferencia')),
  Perfil: lazy(()=> import('pages/perfil/Perfil')),
  COC: lazy(()=> import('pages/coc/COC')),
  Listas: lazy(() => import('pages/listas/Listas')),
  ConsultaDocumento: lazy(() => import('pages/consulta_documento/ConsultaDocumento')),
  PVL: lazy(() => import('pages/pvl/Pvl')),
  Calculos: lazy(() => import('pages/calculo/Calculo')),
  Usuario: lazy(() => import('pages/usuario/Usuario')),
  // CONSULTAS PUBLICAS
  ConsultaPublica: lazy(() => import('pages/consulta_publica/ConsultaPublica')),
  Garantia: lazy(() => import('pages/garantia/Garantia')),
  Panorama: lazy(() => import('pages/panorama/Panorama')),
  PanoramaDocumento: lazy(() => import('pages/panorama/documento/PanoramaDocumento')),
  Endividamento: lazy(() => import('pages/panorama/endividamento/Endividamento')),
  ConsultaPublicaDocumento: lazy(() => import('pages/consulta_documento/ConsultaDocumentoPublico')),
  CatalogoApi: lazy(() => import('pages/catalogo_api/CatalogoApi')),
}

export const features = [
  {
    id: 'HOME',
    subject: {
      name: 'Página inicial'
    },
    name: 'Página inicial',
    description: 'Página inicial do Módulo Operações de Crédito',
    route: { url: '/', path: '/', element: lazyLoader.Home },
    hasPermission: () => true,
    backendId: '',
    requires: [],
    auditable: false
  },
  {
    id: 'LOGIN',
    subject: {
      name: 'Página login'
    },
    name: 'Página login',
    description: 'Página de login do módulo Operações de Crédito e CDP',
    route: { url: 'login', path: 'login/*', element: lazyLoader.Login },
    hasPermission: () => true,
    backendId: '',
    requires: [],
    auditable: false
  },
  {
    id: 'LOGINERRO',
    subject: {
      name: 'Página acesso negado'
    },
    name: 'Página acesso negado',
    description: 'Página de acesso negado do Módulo Operações de Crédito',
    route: { url: 'negado', path: 'negado/*', element: lazyLoader.LoginErro },
    hasPermission: () => true,
    backendId: '',
    requires: [],
    auditable: false
  },
  {
    id: 'PAGE_NOT_FOUND',
    subject: {
      name: 'Página não encontrada'
    },
    name: 'Página não encontrada',
    description: 'Página não encontrada no Módulo Operações de Crédito',
    route: { url: 'page-not-found', path: 'page-notfound/*', element: lazyLoader.PageNotFound },
    hasPermission: () => true,
    backendId: '',
    requires: [],
    public:true,
    auditable: false
  },
  {
    id: 'PAGE_ACCESS_DENIED',
    subject: {
      name: 'Acesso Negado'
    },
    name: 'Acesso Negado',
    description: 'Acesso Negado no Módulo Operações de Crédito',
    route: { url: 'acesso-negado', path: 'acesso-negado/*', element: lazyLoader.PageAccessDenied },
    hasPermission: () => true,
    backendId: '',
    requires: [],
    public:true,
    auditable: false
  },
  {
    id: 'LOGOUT',
    subject: {
      name: 'Página de logout'
    },
    name: 'Página logout',
    description: 'Página de logout do Módulo Operações de Crédito',
    route: { url: 'logout', path: 'logout/*', element: lazyLoader.Logout },
    hasPermission: () => true,
    backendId: '',
    requires: [],
    auditable: false
  },
  {
    id: 'FINALIDADE',
    subject: {
      name: 'Finalidade',
      plural: 'Finalidades'
    },
    name: 'Finalidades',
    description: 'Consultar, Criar ou Editar Finalidades',
    route: { url: 'finalidade', path: 'finalidade/*', element: lazyLoader.Finalidade },
    hasPermission: () => true,
    backendId: FINALIDADE,
    requires: [CON_FINALIDADE],
    auditable: false
  },
  {
    id: 'AUTORIDADE_EMITENTE',
    subject: {
      name: 'Autoridade emitente',
      plural: 'Autoridades emitentes'
    },
    name: 'Autoridades emitentes',
    description: 'Consultar, Criar ou Editar Autoridade Emitente',
    route: { url: 'autoridade-emitente', path: 'autoridade-emitente/*', element: lazyLoader.AutoridadeEmitente },
    hasPermission: () => true,
    backendId: AUT_EMIT,
    requires: [CON_AUT_EMIT],
    auditable: false
  },
  {
    id: 'ADMIN',
    subject: {
      name: 'Admin',
      plural: 'Admin',
      detailsMsg: ' e Dispositivos associados'

    },
    name: 'Admin',
    description: 'Admin',
    route: { url: 'admin', path: 'admin/*', element: lazyLoader.Admin },
    hasPermission: () => true,
    backendId: ADMIN,
    requires: [ALT_PERFIL],
    auditable: false
  },
  {
    id: 'NORMATIVO',
    subject: {
      name: 'Normativo',
      plural: 'Normativos',
      detailsMsg: ' e Dispositivos associados'

    },
    name: 'Normativos',
    description: 'Consultar, Criar ou Editar Normativos',
    route: { url: 'normativo', path: 'normativo/*', element: lazyLoader.Normativo },
    hasPermission: () => true,
    backendId: NORMATIVO,
    requires: [CON_NORMATIVO],
    auditable: false
  },
  {
    id: 'CONDICAO',
    subject: {
      name: 'Condição',
      plural: 'Condições',
      detailsMsg: ', Normativos/Dispositivos, Abrangências e Detalhes associados'
    },
    name: 'Condições',
    description: 'Consultar, Criar ou Editar Condições',
    route: { url: 'condicao', path: 'condicao/*', element: lazyLoader.Condicao },
    hasPermission: () => true,
    backendId: CONDICAO,
    requires: [CON_CONDICAO],
    auditable: false
  },
  {
    id: 'LIMITE',
    subject: {
      name: 'Limite',
      plural: 'Limites',
      detailsMsg: ', Normativos/Dispositivos e Abrangências associados'
    },
    name: 'Limites',
    description: 'Consultar, Criar ou Editar Limites',
    route: { url: 'limite', path: 'limite/*', element: lazyLoader.Limite },
    hasPermission: () => true,
    backendId: LIMITE,
    requires: [CON_LIMITE],
    auditable: false
  },
  {
    id: 'PROGRAMA',
    subject: {
      name: 'Programa',
      plural: 'Programas',
      detailsMsg: ' e Normativos/Dispositivos associados'

    },
    name: 'Programas',
    description: 'Consultar, Criar ou Editar Programas',
    route: { url: 'programa', path: 'programa/*', element: lazyLoader.Programa },
    hasPermission: () => true,
    backendId: PROGRAMA,
    requires: [CON_PROGRAMA],
    auditable: false
  },
  {
    id: 'TIPO_ANALISE',
    subject: {
      name: 'Tipo de análise',
      plural: 'Tipos de análise'

    },
    name: 'Tipos de análise',
    description: 'Consultar, Criar ou Editar Tipos de Análise',
    route: { url: 'tipo-analise', path: 'tipo-analise/*', element: lazyLoader.TipoAnalise },
    hasPermission: () => true,
    backendId: TP_ANALISE,
    requires: [CON_TP_ANALISE],
    auditable: false
  },
  {
    id: 'DEMANDA_JUDICIAL',
    subject:{
      name: 'Demanda judicial',
      plural: 'Demandas judiciais'
    },
    name: 'Demandas judiciais',
    description: 'Consultar, Criar ou Editar Demandas Judiciais',
    route: { url: 'demanda-judicial', path: 'demanda-judicial/*', element: lazyLoader.DemandaJudicial },
    hasPermission: () => true,
    backendId: DEM_JUD,
    requires: [CON_DEM_JUD],
    auditable: false
  },
  {
    id:'PARAMETRO_CALCULO',    
    subject:{
      name: 'Parâmetro de cálculo',
      plural: 'Parâmetros de cálculos'
    },
    name:'Parâmetros de cálculo',
    description:'Consultar, criar, editar e remover parâmetros cálculos ',
    route: {url:'parametro-calculo', path:'parametro-calculo/*', element:lazyLoader.ParametroCalculo},
    hasPermission: () => true,
    backendId: PARAM_CALCULO,
    requires: [CON_PARAM_CALCULO],
    auditable: false
  },
  {
    id:'MODELOQUADROANALISE',    
    subject:{
      name: 'Quadro de análise',
      plural: 'Quadros de análise'
    },
    name:'Quadros de análise',
    description:'Consultar, criar, editar e remover quadro de análise ',
    route: {url:'modelo-quadro-analise', path:'modelo-quadro-analise/*', element:lazyLoader.ModeloQuadroAnalise},
    hasPermission: () => true,
    backendId: MODELO_QUADRO,
    requires: [CON_MODELO_QUADRO],
    auditable: false
  },
  {
    id:'ITEM_VERIFICACAO',    
    subject:{
      name: 'Item de verificação',
      plural: 'Itens de verificação'
    },
    name:'Itens de verificação',
    description:'Consultar, criar, editar e remover itens de verificação ',
    route: {url:'item-verificacao', path:'item-verificacao/*', element:lazyLoader.ItemVerificacao},
    hasPermission: () => true,
    backendId: ITEM_VERIFICACAO,
    requires: [CON_ITEM_VERIFICACAO],
    auditable: false
  },
  {
    id:'LISTA_VERIFICACAO',
    subject:{
      name: 'Lista de verificação',
      plural: 'Listas de verificação'
    },
    name:'Listas de verificação',
    description:'Consultar, criar, editar e remover listas de verificação ',
    route: {url:'lista-verificacao', path:'lista-verificacao/*', element:lazyLoader.ListaVerificacao},
    hasPermission: () => true,
    backendId: LISTA_VERIFICACAO,
    requires: [CON_LISTA_VERIFICACAO],
    auditable: false
  },
  {
    id:'ENTIDADE',
    subject:{
      name: 'Entidade',
      plural: 'Entidades'
    },
    name:'Entidades',
    description:'Consultar, criar, editar e remover entidades ',
    route: {url:'entidade', path:'entidade/*', element:lazyLoader.Entidade},
    hasPermission: () => true,
    backendId: ENTIDADE,
    requires: [CON_ENTIDADE],
    auditable: false
  },
  {
    id:'CALCULOS',
    subject:{
      name: 'Cálculo',
      plural: 'Cálculos'
    },
    name:'Cálculos',
    description:'Consultar, criar, editar e remover cálculos ',
    route: {url:'calculos', path:'calculos/*', element:lazyLoader.Calculos},
    hasPermission: () => true,
    backendId: CALCULOS,
    requires: [CON_CALCULOS],
    auditable: false
  },
  {
    id:'LIMITE_SIMULACAO',    
    subject:{
      name: 'Simular limite',
      plural: 'Simular limites'
    },
    name:'Simular limites',
    description:'Simular anáĺise de limite ',
    route: {url:'limite-simulacao', path:'limite-simulacao/*', element:lazyLoader.LimiteSimulacao},
    hasPermission: () => true,
    backendId: SIM_LIMITE,
    requires: [CON_SIM_LIMITE],
    auditable: false
  },
  {
    id:'PREFERENCIAS',    
    subject:{
      name: 'Preferências',
      plural: 'Preferências'
    },
    name:'Preferências',
    description:'Gerenciar preferências ',
    route: {url:'preferencia', path:'preferencia/*', element:lazyLoader.Preferencias},
    hasPermission: () => true,
    backendId: PREFERENCIAS,
    requires: [CON_PREFERENCIAS],
    auditable: false
  },
  {
    id:'PERFIL',    
    subject:{
      name: 'Perfil',
      plural: 'Perfis'
    },
    name:'Permissões',
    description:'Gerenciar perfis ',
    route: {url:'perfil', path:'perfil/*', element:lazyLoader.Perfil},
    hasPermission: () => true,
    backendId: PERFIL,
    requires: [CON_PERFIL],
    auditable: false
  },
  {
    id:'COC',    
    subject:{
      name: 'Operação de crédito',
      plural: 'Operações de crédito'
    },
    name:'Operações de crédito',
    description:'Gerenciar cadastro de operações de crédito ',
    route: {url:'coc', path:'coc/*', element:lazyLoader.COC},
    hasPermission: () => true,    
    backendId: COC,
    requires: [CON_COC],
    auditable: true
  },
  {
    id:'GARANTIA',
    subject:{
      name: 'Garantia',
      plural: 'Garantias'
    },
    name:'Garantias',
    description:'Consultar, criar, editar e remover garantias ',
    route: {url:'garantia', path:'garantia/*', element:lazyLoader.Garantia},
    hasPermission: () => true,
    backendId: GARANTIA,
    requires: [CON_GARANTIA],
    auditable: true
  },
  {
    id:'PANORAMA',
    subject:{
      name: 'Panorama',
      plural: 'Panoramas'
    },
    name:'Panorama',
    description:'Consultar panorama do ente federativo',
    route: {url:'panorama', path:'panorama/*', element:lazyLoader.Panorama},
    hasPermission: () => true,
    backendId: PANORAMA,
    requires: [CON_PANORAMA],
    auditable: false
  },
  {
    id:'PVL',    
    subject:{
      name: 'PVL',
      plural: 'PVLs'
    },
    name:'PVL',
    description:'Pedidos de verificação de limites e condições ',
    route: {url:'pvl', path:'pvl/*', element:lazyLoader.PVL},
    hasPermission: () => true,
    backendId: PVL,
    requires: [CON_PVL],
    auditable: true
  },
  {
    id: 'LISTAS',
    subject: {
      name: 'Lista',
      plural: 'Listas',
    },
    name: 'Listas',
    description: 'Consultar ou editar listas',
    route: { url: 'listas', path: 'listas/*', element: lazyLoader.Listas },
    hasPermission: () => true,
    backendId: LISTAS,
    requires: [CON_LISTAS],
    auditable: false
  },
  {
    id:'CONSULTA_DOCUMENTO',    
    subject:{
      name: 'Consulta documento',
      plural: 'Consulta documentos'
    },
    name:'Documentos',
    description:'Consultar documentos que estão armazenados',
    route: { url:'consulta-documento', path:'consulta-documento/*', element:lazyLoader.ConsultaDocumento},
    hasPermission: () => true,
    backendId: CONSULTA_DOCUMENTO,
    requires: [CON_CONSULTA_DOCUMENTO],
    auditable: false    
  },
  // CONSULTAS PUBLICAS
  {
    id:'CONSULTA_PUBLICA',    
    subject:{
      name: 'Consulta pública',
      plural: 'Consultas públicas'
    },
    name:'Consultas públicas',
    description:'Consultar entidades que não apresentam restrição de acesso',
    route: { url:'consultas-publicas', path:'consultas-publicas/*', element:lazyLoader.ConsultaPublica},
    hasPermission: () => false,
    backendId: '',
    requires: [CON_PUBLICO_NORMATIVO,CON_PUBLICO_DEM_JUD,CON_PUBLICO_PVL],    
    public:true,
    auditable: false
  },

  {
    id:'CONSULTA_PUBLICA_DOCUMENTO',    
    subject:{
      name: 'Consulta documento',
      plural: 'Consulta documentos'
    },
    name:'Documentos',
    description:'Detalhar documento a partir do identificador Siconfi',
    route: { url:'ver', path:'ver/:id', element:lazyLoader.ConsultaPublicaDocumento},
    hasPermission: () => false,
    backendId: '',
    requires: [CON_CONSULTA_DOCUMENTO,CON_PUBLICO_ELEMENTO],
    public:true,
    auditable: false
  },
  // {
  //   id: "TUTORIAL_API_SADIPEM",
  //   name: "Tutorial API Sadipem",
  //   description: "Documentação de uso da API Sadipem",
  //   route: {
  //     url: "tutorial-api-sadipem",
  //     path: "tutorial-api-sadipem",
  //     element: lazyLoader.TutorialApiSadipem,
  //   },
  //   hasPermission: () => false,
  //   public:true,
  //   requires: [],
  // },
  {
    id: 'CATALOGO_API',
    subject: {
      name: 'Catálogo de APIs e documentações de integração',
      plural: 'Catálogo de APIs e documentações de integração'
    },
    name: 'Catálogo de APIs e documentações de integração',
    description: 'Catálogo de APIs e documentações de integração',
    route: { url: 'catalogo-api', path: 'catalogo-api/*', element: lazyLoader.CatalogoApi },
    hasPermission: () => true,
    backendId: '',
    requires: [],
    public: true,
    auditable: false
  },
  {
    id:'PAN_DOC_ENTE',    
    subject:{
      name: 'Documento',
      plural: 'Documentos'
    },
    name:'Documento',
    description:'Documento do ente federativo',
    route: {url: 'panorama/:codigoIbge/documento', path: 'panorama/:codigoIbge/documento/*', element:lazyLoader.PanoramaDocumento},
    hasPermission: () => true,
    backendId: PAN_DOC_ENTE,
    requires: [CON_PAN_DOC_ENTE],
  },
  {
    id:'PAN_ENDIVIDAMENTO',    
    subject:{
      name: 'Quadro de Endividamento',
      plural: 'Quadro de Endividamento'
    },
    name:'Quadro de Endividamento',
    description:'Quadro de Endividamento',
    route: {url: 'panorama/:codigoIbge/endividamento', path: 'panorama/:codigoIbge/endividamento/*', element:lazyLoader.Endividamento},
    hasPermission: () => true,
    backendId: PAN_ENDIVIDAMENTO,
    requires: [CON_PAN_ENDIVIDAMENTO],
  },
  {
    id: 'USUARIOS',
    subject: {
      name: 'Usuário',
      plural: 'Usuários'
    },
    name: 'Usuários',
    description: 'Cadastro de Usuários',
    route: { url: 'usuario', path: 'usuario/*', element: lazyLoader.Usuario },
    hasPermission: () => true,
    backendId: USUARIO,
    requires: [CON_USUARIO],
  }

];

export const getFeature = (id) => features.find(f => f.id === id);
export const findFeature = (findFn) => features.find(f => findFn(f));
